import React, { useState } from "react";
import moment from "moment";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import Card from "components/Card/Card";
import Datetime from "react-datetime";
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATE_FORMAT_WITH_MONTH,
} from "../../scripts/const";
import { groupBy } from "lodash";
import Accordion from "../Accordion/Accordion";
import "./style.css";

function Todo({ todo, completeTodo, editTodo, deleteTodo, allowDelete }) {
  const [edit, setEdit] = useState(false);
  const [detail, setDetail] = useState("");
  const [dueDate, setDueDate] = useState("");

  const editDetail = (detail) => {
    setDetail(detail);
    setEdit(true);
  };

  const handleDatePicker = (date) => {
    if (moment.isMoment(date)) {
      setDueDate(date.format(DEFAULT_DATE_FORMAT).toString());
    } else {
      setDueDate(date);
    }
  };

  const getAction = () => {
    return edit ? (
      <div
        style={{
          display: "flex",
        }}
      >
        <button
          className="todo-add-btn"
          onClick={() => {
            setEdit(false);
            setDetail(todo.detail);
          }}
        >
          x
        </button>
      </div>
    ) : (
      <div
        style={{
          display: "flex",
          gap: "5px",
        }}
      >
        <button
          className="todo-add-btn"
          onClick={() => editDetail(todo.detail)}
        >
          ✎
        </button>
        <button className="todo-add-btn" onClick={() => completeTodo(todo.id)}>
          ✓
        </button>
      </div>
    );
  };
  return (
    <div className="todo">
      {edit ? (
        <div
          style={{
            display: "flex",
            gap: "10px",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <input
            type="text"
            className="input-todo"
            style={{
              display: "flex",
              flex: 1,
              borderRadius: "10px",
            }}
            value={detail}
            onChange={(e) => setDetail(e.target.value)}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span>Due: &nbsp;</span>

            <Datetime
              closeOnSelect
              timeFormat={false}
              dateFormat={DEFAULT_DATE_FORMAT}
              value={dueDate || ""}
              onChange={(moment) => handleDatePicker(moment)}
              inputProps={{
                name: "dueDate",
                placeholder: `${DEFAULT_DATE_FORMAT}`,
              }}
            />
          </div>
          <div>
            <button
              className="todo-add-btn"
              onClick={() => {
                setEdit(false);
                editTodo(todo.id, detail, dueDate);
              }}
            >
              Update
            </button>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flex: "1",
            gap: "10px",
          }}
        >
          <span
            style={{
              display: "flex",
              flex: "0.6",
              hyphens: "auto",
            }}
          >
            {todo.detail}
          </span>
          <div
            style={{
              justifyContent: "space-around",
              flex: "0.4",
              display: "flex",
            }}
          >
            <span
              style={{
                width: "50%",
                display: "flex",
                alignItem: "flex-start",
              }}
            >{`Due: ${
              todo?.dueDate
                ? moment(todo.dueDate, DEFAULT_DATE_FORMAT).format(
                    DEFAULT_DATE_FORMAT_WITH_MONTH
                  )
                : "N/A"
            }`}</span>
            <span
              style={{
                width: "50%",
                display: "flex",
                alignItem: "flex-start",
              }}
            >{`Created: ${moment(todo.createdAt).format(
              DEFAULT_DATE_FORMAT_WITH_MONTH
            )}`}</span>
          </div>
        </div>
      )}
      {todo.isCompleted
        ? allowDelete && (
            <div
              style={{
                display: "flex",
              }}
            >
              <button
                className="todo-add-btn"
                onClick={() => deleteTodo(todo.id)}
              >
                x
              </button>
            </div>
          )
        : getAction()}
    </div>
  );
}

function TodoForm({ addTodo, loggedUserId }) {
  const [detail, setDetail] = useState("");
  const [dueDate, setDueDate] = useState("");

  const handleDatePicker = (date) => {
    if (moment.isMoment(date)) {
      setDueDate(date.format(DEFAULT_DATE_FORMAT).toString());
    } else {
      setDueDate(date);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!detail) return;
    addTodo(detail, dueDate, loggedUserId);
    setDetail("");
    setDueDate("");
  };

  return (
    <div
      className="todo"
      style={{
        justifyContent: "space-between",
        display: "flex",
        gap: "10px",
      }}
    >
      <input
        style={{
          flex: 1,
          display: "flex",
        }}
        type="text"
        className="input"
        value={detail}
        onChange={(e) => setDetail(e.target.value)}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
          className="toto-due-date"
        >
          <span>Due: &nbsp;</span>

          <Datetime
            closeOnSelect
            timeFormat={false}
            dateFormat={DEFAULT_DATE_FORMAT}
            value={dueDate || ""}
            onChange={(moment) => handleDatePicker(moment)}
            inputProps={{
              name: "dueDate",
              placeholder: `${DEFAULT_DATE_FORMAT}`,
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <button onClick={handleSubmit} className="todo-add-btn">
            Add
          </button>
        </div>
      </div>
    </div>
  );
}

function TodoComponent({
  todos,
  loggedUserId,
  addTodo,
  completeTodo,
  editTodo,
  deleteTodo,
  allowDelete = true,
}) {
  function getCompletedTodo() {
    const completedTodo = [
      ...todos.filter(
        (todo) => todo.userId === loggedUserId && todo.isCompleted === true
      ),
    ].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    const allDates = completedTodo.map((m) => ({
      ...m,
      date: moment(m.updatedAt).format("MMMM D, YYYY (dddd)"),
    }));
    const dateTodo = groupBy(allDates, (todo) => todo.date);
    const components = [];
    for (let property in dateTodo) {
      if (dateTodo.hasOwnProperty(property)) {
        components.push(
          <div
            style={{
              backgroundColor: "#4c84ca",
              width: "95%",
              textAlign: "center",
              color: "white",
            }}
            key={property}
          >
            Date: {property}
          </div>
        );
        components.push(
          dateTodo[property].map((todo, index) => (
            <GridItem key={index} xs={12} sm={12} md={12}>
              <Todo
                key={index}
                index={index}
                todo={todo}
                completeTodo={completeTodo}
                editTodo={editTodo}
                deleteTodo={deleteTodo}
                allowDelete={allowDelete}
              />
            </GridItem>
          ))
        );
      }
    }
    return components;
  }
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader style={{ textAlign: "center" }} color="primary" stats>
            <h3>ToDo</h3>
          </CardHeader>
          <CardBody>
            <GridContainer justifyContent={"center"}>
              {todos
                .filter(
                  (todo) =>
                    todo.userId === loggedUserId && todo.isCompleted === false
                )
                .map((todo, index) => (
                  <GridItem key={index} xs={12} sm={12} md={12}>
                    <Todo
                      key={index}
                      index={index}
                      todo={todo}
                      completeTodo={completeTodo}
                      editTodo={editTodo}
                      deleteTodo={deleteTodo}
                    />
                  </GridItem>
                ))}
            </GridContainer>
            <GridContainer justifyContent={"center"}>
              <GridItem xs={12} sm={12} md={12}>
                <TodoForm addTodo={addTodo} loggedUserId={loggedUserId} />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader style={{ textAlign: "center" }} color="success" stats>
            <h3>Completed</h3>
          </CardHeader>
          <Accordion
            summaryStyle={{
              backgroundColor: "#bee9c9",
              margin: "-5px 15px auto",
              padding: "15px",
              borderRadius: "5px",
            }}
            collapses={[
              {
                title: "",
                content: (
                  <CardBody>
                    <GridContainer justifyContent={"center"}>
                      {getCompletedTodo()}
                    </GridContainer>
                  </CardBody>
                ),
              },
            ]}
          />
        </Card>
      </GridItem>
    </GridContainer>
  );
}

export default TodoComponent;
